import { z } from 'zod';

export function createAdminV2WorkspaceInputLabelsSchema(
  localizedTextSchema: z.ZodType<Record<string, string>>
) {
  return z
    .object({
      primaryImage: localizedTextSchema.optional(),
      referenceImage: localizedTextSchema.optional(),
      frameMode: localizedTextSchema.optional(),
    })
    .strict();
}
